import { render, staticRenderFns } from "./dangerMasterDetail.vue?vue&type=template&id=61d77fe8"
import script from "./dangerMasterDetail.vue?vue&type=script&lang=js"
export * from "./dangerMasterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d77fe8')) {
      api.createRecord('61d77fe8', component.options)
    } else {
      api.reload('61d77fe8', component.options)
    }
    module.hot.accept("./dangerMasterDetail.vue?vue&type=template&id=61d77fe8", function () {
      api.rerender('61d77fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/danger/dangerMasterDetail.vue"
export default component.exports